// @ actions
const signaturePatternActions = require('actions/signaturePattern');
// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const {APIPost} = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const cardReplaceRequest = ()  => ({
    type: actionTypes.SET_CARD_REPLACE_REQUEST
})

const cardReplaceSuccess = ()  => ({
    type: actionTypes.SET_CARD_REPLACE_SUCCESS
})

const cardReplaceFailure = (error)  => ({
    type: actionTypes.SET_CARD_REPLACE_FAILURE,
    payload: {
        error
    }
})

const clearCardReplace = ()  => ({
    type: actionTypes.SET_CARD_REPLACE_INITIAL
})

const replaceCardCallback = (cardId, dataToken) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const pan = immCard.get('number');
    const producto = immCard.getIn(['contract', 'product']);
    const numerodecontrato = immCard.getIn(['contract', 'number']);

    const requestData = {
        query: {
            contratoTarjeta: {
                numerodecontrato,
                producto
            },
            dataToken,
            pan
        }
    };

    dispatch(cardReplaceRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('cardReplace'), requestData)
        .then(response => dispatch(cardReplaceSuccess(response)))
        .catch(response => {
            if (response.error) {
                dispatch(cardReplaceFailure(response.error.description));
            }
            throw response;//This is needed to cath the replace error in the block and replace flow
        });
};

const replaceCard = (cardId) => (dispatch, getState) => {
    const secondaryCallback = (dispatch, getState, dataToken) => dispatch(replaceCardCallback(cardId, dataToken));
    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, secondaryCallback);
    });
};

module.exports = {
    clearCardReplace,
    replaceCard,
    replaceCardCallback
};
